exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.link-list {\n  white-space: nowrap !important;\n  max-width: 180px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.purple {\n  color: #ffffff;\n  background-color: #964ed8;\n}\n.purple:hover {\n  color: #ffffff;\n  background-color: #964EED;\n}\n", ""]);

// exports
